module.exports = "{{ 'WEEKDAYS-LONG.' + [date.getDay()] | translate }}, \r\n{{ date.getDate() }} {{ 'MONTHS-LONG.' + [date.getMonth()] | translate }} {{ date.getFullYear() }}, \r\n{{ 'HOUR' | translate}} {{ getHour() }}:{{ getMinute() }}"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/current-date/current-date.component.html
// module id = ./src/app/shared/components/current-date/current-date.component.html
// module chunks = main